export const IconSection = {
  flow: 'x',
  align: 'flex-start',
  gap: 'A',

  IconCol: {
    align: 'flex-start center',
    color: 'caption',
    SectionIcon: {
      extends: 'Icon',
      margin: 'W2 - -',
      icon: (el) => el.parent.parent.icon || 'state'
    }
  },

  Right: {
    flow: 'y',
    gap: 'A',
    flex: '1',
    minWidth: '0',

    Intro: {
      flow: 'x',
      gap: 'Z',
      align: 'baseline',
      flexWrap: 'wrap',
      childExtends: 'IntroRun',
      childrenAs: 'state',
      // Host (Working/Requested/...) supplies `introBuilder: (el, s) => [...]`
      // for the chip array. The earlier prop name `intro` collided with
      // DOMQL v3.14's auto-factory pass — DOMQL invokes function-valued
      // element props at create-time and stores the result on the element.
      // Consumer functions were declared `(s) => ...` while DOMQL calls
      // them as `(el, state)`, so the body received `el` as `s`, threw on
      // `s.root.myTickets`, and the property settled at `undefined` — that
      // produced the "Intro lacks text" UX bug. Renaming to `introBuilder`
      // + fixing the consumer signature to `(el, s)` lets DOMQL invoke
      // the factory cleanly so the resolved array lands directly on the
      // host element. Walk-up tolerates Working/Requested's `Right`
      // overrides (which splice in their own Body/Empty).
      children: (el, s) => {
        let n = el.parent
        while (n && typeof n.introBuilder === 'undefined') n = n.parent
        if (!n) return []
        const ib = n.introBuilder
        if (Array.isArray(ib)) return ib
        if (typeof ib === 'function') {
          try {
            const r = ib(el, s)
            return Array.isArray(r) ? r : []
          } catch (_) {
            return []
          }
        }
        return []
      }
    }
  }
}

// `IntroRun` (used by `childExtends: 'IntroRun'` above) is defined ONCE, in
// IntranetRows.js. It used to be duplicated here byte-for-byte, and because
// components/index.js star-exports BOTH files the name became an ambiguous
// re-export — which ESM resolves by omitting it from the namespace entirely,
// so the shared context could end up with no `IntroRun` at all. The string
// reference resolves through the merged context, so nothing needs importing.
